import { Injectable } from '@angular/core';
import { RestService } from '../_rest.service';

@Injectable({
  providedIn: 'root'
})
export class ForumEvenementLieuService extends RestService{

  init(){
    this.endpoint = 'evenementlieux';
    this.modelname = 'evenementlieu';
    }
}
